import React from "react";
import { Modal, Button } from "react-bootstrap";
import { apiDeleteProcess } from "../../../api/ApiProcess";
import { useTranslation } from "react-i18next";

const ModalDelete = (props) => {
  const { id, show, handleClose, handleRecupDatas } = props;
  const { t } = useTranslation();

  const submitData = async () => {
    await apiDeleteProcess(id);
    handleRecupDatas();
    handleClose();
  };

  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>
          {t("admin.PageAdminProcesses.modalDeleteTitre")}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>{t("admin.PageAdminProcesses.modalDeleteText")}</Modal.Body>
      <Modal.Footer>
        <Button variant="danger" onClick={handleClose}>
          {t("commun.form.button.annuler")}
        </Button>
        <Button variant="success" onClick={submitData}>
          {t("commun.form.button.confirmSuppression")}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalDelete;
